import React from 'react'
import { Button } from '@foodsby/nutrient'
const FOODSBY_BASE_URL = process.env.REACT_APP_FOODSBY_BASE_URL

const RestaurantLogin = () => (
  <section className="restaurant-login">
    <h2 className="restaurant-login_title">
      Are you a restaurant trying to login to your account?
    </h2>
    <p>Click on the button below to go to the restaurant login page.</p>
    <Button
      className="button restaurant-login_button"
      onClick={() =>
        (window.location.href = `${FOODSBY_BASE_URL}/main/restaurants-login`)
      }
      rel="noopener noreferrer"
      target="_blank"
    >
      <i className="icon-lock" /> Restaurant Login
    </Button>
  </section>
)

export default RestaurantLogin
